import {RefObject} from 'react';
import {Size, useContainerSize} from './useContainerSize';
import {useScale} from './useScale';

/**
 * useAutoScale
 * Combines container measurement and scale computation.
 * Returns scale to fit the given image size into the container referred by ref.
 */
export function useAutoScale(ref: RefObject<HTMLElement>, image: { width: number; height: number } | null): number {
  const containerSize: Size = useContainerSize(ref);
  return useScale(image, containerSize);
}
